import PropTypes from 'prop-types';

const Image = (props) => {

  const {
    classImage,
    classes,
    src,
  } = props;

  return (
    <div className={classes}>
      <img src={src} className={classImage} alt='...' />
    </div>
  )
}

Image.proTypes = {
  classImage: PropTypes.string,
  src: PropTypes.string,
  classes: PropTypes.string,
}

export default Image;